import { setNotifications } from '../actions';
import { identityPayload, createReducer, forAction } from '../utils';

const initialState = [];

export default createReducer(
  [forAction(setNotifications, identityPayload)],
  initialState,
);
